import { z } from 'zod';
import { ESTADOS, MOTIVO_MIN, RUC_REGEX, exigeMotivo } from '../dominio.js';
export const uuid = z.uuid({ message: 'Identificador inválido' });
export const ruc = z
    .string()
    .trim()
    .regex(RUC_REGEX, 'El RUC debe tener 11 dígitos y empezar en 10, 15, 17 o 20');
export const correo = z.email({ message: 'Correo inválido' }).max(150);
/**
 * Un campo de texto vacío en un formulario significa «sin valor», no «cadena
 * vacía». Sin esto, un correo opcional en blanco falla la validación de email.
 */
export function opcional(esquema) {
    // El .optional() externo es imprescindible: z.preprocess() devuelve un
    // esquema REQUERIDO, así que sin él un campo omitido falla la validación.
    return z
        .preprocess((v) => (typeof v === 'string' && v.trim() === '' ? null : v), esquema.nullable())
        .optional();
}
export const estado = z.enum(ESTADOS);
/** Paginación estándar de todos los listados. */
export const paginacion = z.object({
    pagina: z.coerce.number().int().min(1).default(1),
    porPagina: z.coerce.number().int().min(1).max(100).default(25),
    buscar: z.string().trim().max(120).optional(),
});
export function respuestaPaginada(item) {
    return z.object({
        datos: z.array(item),
        total: z.number().int(),
        pagina: z.number().int(),
        porPagina: z.number().int(),
    });
}
/**
 * Transición de estado. El motivo es obligatorio para Observado y Anulado:
 * la misma regla que impone el CHECK chk_motivo_obligatorio en la base.
 */
export const transicion = z
    .object({
    estado: estado,
    motivo: z.string().trim().max(1000).optional(),
})
    .refine((v) => !exigeMotivo(v.estado) || (v.motivo?.length ?? 0) >= MOTIVO_MIN, {
    path: ['motivo'],
    message: `Observar o anular exige un motivo de al menos ${MOTIVO_MIN} caracteres`,
});
export const errorApi = z.object({
    error: z.string(),
    mensaje: z.string(),
    detalle: z.string().optional(),
});
//# sourceMappingURL=comunes.js.map